export const STORAGE_KEY_FILTER_TEMPLATES = 'TETU_GAME_FILTER_TEMPLATES';
